// https://github.com/microsoft/TypeScript/issues/17002
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isArray(value: unknown): value is any[] | readonly any[] {
	return Array.isArray(value);
}

/**
 * TS has no native way to require an array literal to contain exactly every member of a union type.
 * This makes that a compile-time error: omitting a member, or including a value outside the union, fails to typecheck.
 * @example
 * type Locale = 'en-US' | 'fr-FR';
 * const locales = arrayOfAll<Locale>()(['en-US', 'fr-FR']); // readonly Locale[]
 * @knip-ignore
 */
export const arrayOfAll =
	<T>() =>
	<U extends readonly T[]>(array: U & ([T] extends [U[number]] ? unknown : never)): Readonly<U> =>
		array;
